'use strict';

/*global MapItemAbstract */

function MapItem(data) {
    MapItemAbstract.call(this, data);
}

MapItem.prototype = $.extend({}, MapItemAbstract.prototype, {
    construtor: 'MapItem',

    cloneMapItem: function cloneMapItem() {
        var _this = this;

        var newMapItem = new MapItem();
        for(var param in _this) {
            if($.inArray(param, ['marker']) < 0) {
                newMapItem[param] = _this[param];
            }
        }
        return newMapItem;
    }
});
